import { InsertCustomCategoryRequest, PerksCategoriesWithExpenseResponse, insertCustomCategory } from 'core'

import { DefaultSelect, Notification, Option, SimpleInput } from 'common/components'
import { useCommandRequestV2 } from 'common/hooks'

type SelectAndAddPerkProps = {
  perkCategories: PerksCategoriesWithExpenseResponse[]
  productClassId?: string
  name: string
  onChange?: (arg: any) => any
  onSubmit?: (perkId: string, perkName: string) => any
}
const SelectAndAddPerk = ({ perkCategories, productClassId, name, onChange, onSubmit }: SelectAndAddPerkProps) => {
  const { sendCommand: sendInsertCustomCategory, isLoading: loading } = useCommandRequestV2(
    (request: InsertCustomCategoryRequest) => insertCustomCategory(request),
  )

  const submitCustomPerk = async (perkId: string, perkName: string) => {
    let request = { name: perkName, relationId: perkId }
    const result = await sendInsertCustomCategory(request)
    if (result.errors.length <= 0) {
      onSubmit(result.data, perkName)
    } else {
      Notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }
  return (
    <>
      <DefaultSelect
        label={'Select a perk category'}
        labelStyles="mb-12"
        name={name}
        placeholder={'Choose perk category'}
        className="select_perk"
        showRequiredSign={true}
        onChange={onChange}
        dropdownRender={(menu) => (
          <>
            {menu}
            <SimpleInput
              onPressEnter={(e) => {
                e.stopPropagation()
                e.preventDefault()
                submitCustomPerk(productClassId, e.currentTarget.value)
              }}
              placeholder="Add custom perk"
              className={'mt-4 w-auto'}
              autoFocus
            />
          </>
        )}
      >
        {perkCategories?.map((item) => (
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        ))}
      </DefaultSelect>
    </>
  )
}

export default SelectAndAddPerk
